module.exports = __webpack_public_path__ + "img/b9d3a3f30be8dd957c5b4da1a3ad60b3.png";